import { Quote } from "./quote";
export class Template {
    templateId: string;
    templateTitle: string;
    type: string;
    quote: Quote;
    dataCreated: Date;
}
